export default __webpack_public_path__ + "static/media/70t.755e2b09.jpg";